/**
 * Extracts a string message from an error value for logging purposes.
 *
 * Handles Error objects, strings, and any object with a message property.
 * Falls back to 'Unknown error' if no message can be extracted.
 */
export const formatErrorForLogging = (
  error: unknown,
  fallback = 'Unknown error',
): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string'
  ) {
    return error.message;
  }

  return fallback;
};
